module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.unscope.js
 ** module id = 92
 ** module chunks = 0
 **/